import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
  createAccessrule,
  fetchAccessRuleList,
  editAccessrule,
} from "@/services/accessrule";
@Module({
  namespaced: true,
})
export default class AccessRule extends VuexModule {
  // state
  accessList = [];

  //action
  @Action
  public async createAccessrule(payload) {
    try {
      return await createAccessrule(payload);
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async accessRuleList() {
    try {
      const response = await fetchAccessRuleList();
      const list = response.data?.response || response.data || [];
      this.context.commit("setAccessRuleList", list);
      return list;
    } catch (error) {
      throw error;
    }
  }

  @Action
  public async editAccessrule(payload) {
    try {
      return await editAccessrule(payload);
    } catch (error) {
      throw error;
    }
  }

  //mutation
  @Mutation
  public setAccessRuleList(data: any) {
    this.accessList = data;
  }

  //getters
  get GetAccessRuleList() {
    return this.accessList;
  }
}
